export default {
    'remaining-materials': 'Remaining Materials',
    'ravages': 'Ravage',
    'free-distribution': 'Free distribution',
    'returnable': 'Returnable',
    'modify-transfer': 'Modify transfer',
    'reason': 'Reason'
}